import { render, staticRenderFns } from "./BudgetSheetProperties.vue?vue&type=template&id=fa17714e&scoped=true"
import script from "./BudgetSheetProperties.vue?vue&type=script&lang=ts"
export * from "./BudgetSheetProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa17714e",
  null
  
)

export default component.exports